module.exports = __webpack_public_path__ + "media/images/front/premium-cda70c3cb6e0428f943dbe145f0f9f48.png";